/**
 * ? @description : Title Bar Component
 */

// Dependencies
import React, { useEffect, useState } from "react";
import { Navbar } from "react-bootstrap";

// Asset
import ltelogo from "../assets/logov1.svg";

// CSS Component
import "./TitleBar.css";

// About LTE Modal
import AboutModal from "./AboutModal";

export default function TitleBar() {
  const [aboutModal, setAboutModal] = useState(false);

  const aboutLte = () => {
    setAboutModal(true);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setAboutModal(true)
    }, 1000)
     return ()=> clearTimeout(timeout)
  },[]) 

  return (
    <div>
      <Navbar bg="primary" variant="dark" className="lte-title">
        <Navbar.Brand style={{cursor: "pointer"}} onClick={aboutLte}>
            <img src={ltelogo} alt="Logo" className="lte-logo" />
            <span className="lte-logo-title">Let's Teach English</span>
        </Navbar.Brand>
      </Navbar>

      <AboutModal show={aboutModal} onHide={() => setAboutModal(false)} />
    </div>
  );
}
